import React, { useEffect, useRef, useState } from 'react'
import Noresult from '../noresult/noresult'
import Pagination from '../pagination/pagination'

import './search-results.css'
import { getFileNameWithoutExtension, getSources } from '../../Global'
import Buttons from '../buttons/buttons'
import InputSearch from '../../utils/controls/input-search'

const itemsPerPage = 10 // Define how many items to display per page

export default function Searchresults({ history,chathistory,loginUserRoles,getPDFSource ,isSearchResultsFullScreenExpand,showSearchResultsExpandFull, activePdfSource }: { history: { query: string; response: string }[],chathistory:any,loginUserRoles:any,getPDFSource:any,activePdfSource:any, isSearchResultsFullScreenExpand: boolean,showSearchResultsExpandFull: () => void}) {
    // const [currentPage, setCurrentPage] = useState<number>(1)
    // const [currentItems, setCurrentItems] = useState<any>([])
    const [visibleCount, setVisibleCount] = useState<number>(itemsPerPage)
    const triggerRef = useRef<HTMLDivElement>(null)
    const [showCitationPopup, setShowCitationPopup] = useState<any>(null)
    const citationItemRef = useRef<any>(null)
    const [ popUpTop, setPopUpTop ] = useState<any>()
    const [ popUpRight, setPopUpRight ] = useState<any>()
    const [indexs,setIndex] = useState<any>('')
    const [mainitemindex,setmainindex] = useState<any>('')

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisibleCount((prevCount) =>
                        Math.min(prevCount + itemsPerPage, chathistory.length)
                    )
                }
            },
            { threshold: 1.0 } 
        )

        const currentTrigger = triggerRef.current
        if (currentTrigger) {
            observer.observe(currentTrigger)
        }

        return () => {
            if (currentTrigger) {
                observer.unobserve(currentTrigger)
            }
        }
    }, [chathistory, visibleCount]) 

    useEffect(() => {
        if (citationItemRef.current) {
            const mainBtnProps:any = citationItemRef.current.getBoundingClientRect()
            setPopUpTop(mainBtnProps.height + 3)
            setPopUpRight(mainBtnProps.right - mainBtnProps.width)
        }
       
    }, [showCitationPopup])
    
    const jsonparser = (data: any, indexss: any) => {
        if (data) {
            const sourcesArray = getSources(data)
            return (
                <div className="citation-container">
                    {sourcesArray?.map((source: any, index: any) => {
                        const sourceFileName = String(source).trim()
                        const cleanedFileName = getFileNameWithoutExtension(sourceFileName)
                        return (
                            <div key={index} className="p-relative maxfitcontent d-flex gap-1">
                                    <a
                                        className={`citation-item ${sourceFileName === activePdfSource ? 'active' : ''}`}
                                        ref={citationItemRef} 
                                        href="/#"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            getPDFSource(sourceFileName)
                                        }}
                                        onMouseEnter={() => { setShowCitationPopup(true); setIndex(index); setmainindex(indexss) }}
                                        onMouseLeave={() => setShowCitationPopup(false)}
                                        title={cleanedFileName}
                                    >
                                        <span className='icon-pdf-outline p-1 bgcolor-27 border-radius4 me-2 whitetext'></span>
                                        {cleanedFileName}
                                        <span className='icon-arrow-45deg font-10 mx-2'></span>
                                    </a>
                            </div>
                        )
                    })}
                </div>
            )
        } else {
            return null
        }
    }
    
    
    // Handle page change
    // const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber)

    return (
        <>        
            <div className='bordered1 card card-lg border-radius3 shadow'>
                <div className="card-header p-3 py-2 d-flex justify-content-between align-items-center border-bottom1">
                    <h2 tabIndex={0} aria-label='Search Results' className='segoeui-semibold font-18'>Search Results</h2>
                    <div className="d-flex align-items-center gap-1">
                        <InputSearch
                            inputProps={{
                                placeholder: 'Search',
                                arialabel: 'search',
                            }}
                            className='form-sm border-radius3 w-100 border-2'
                            label=""
                            searchgroup='w-100 d-flex align-items-center inputswithlicon'
                            formClassName='min-w-200'
                            licon='icon-search px-2 color-primary font-15'
                        />
                        <div className="dividerdashed vertical mx-1"></div>
                        <Buttons
                            label={isSearchResultsFullScreenExpand ? 'Fullscreen collapsed' : 'Expand Fullscreen'}
                            className="font-0 color-primary ms-auto"
                            icon={isSearchResultsFullScreenExpand ? 'icon-shrink2 font-14 me-0' : 'icon-expand font-14 me-0'}
                            onClick={showSearchResultsExpandFull}
                        />
                    </div>
                </div>
                <div className="d-flex flex-column p-3 py-0 mb-2 card-body search-results">
                    {chathistory?.slice(0, visibleCount).map((item: any, index: any) => (
                        <div key={item.id || index} id={item.id}>
                            <div className="widget-data d-flex flex-column border-bottom1 font-13 py-3 dashed-border">
                                <div className="d-flex flex-column gap-1">
                                    <p className="m-0 segoeui-semibold font-13 darktext lineclamp1 ms-auto bordered11 bgcolor-29 border-radius1 py-1 px-2 color-primary text-end">
                                        {item.query}
                                    </p>
                                    <div className='font-11 subtitle-color ms-auto'>
                                        {item?.formattedTimestamp?.split(',')[0]} | {item?.formattedTimestamp?.split(',')[1]}
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <div>
                                        <img src='/assets/images/usaf-logo.svg' className='p-1 bgcolor-28 border-radius4 bordered11' alt='USAF SAF/FMBOP' height={30} width={30} />
                                    </div>
                                    {item?.sources && (
                                        <div className='py-2 d-flex flex-column gap-2'>
                                            <div className='segoeui-semibold font-16'>
                                                <span className='icon-book-open bold color-primary me-1 font-12'></span>
                                                Citations
                                            </div>
                                            <span>{jsonparser(item?.sources, index)}</span>
                                        </div>
                                    )}
                                    <p className="font-13 py-1">
                                        <div className='segoeui-semibold font-14 mb-2'>
                                            <span className='icon-bulb bold color-primary me-1 font-16'></span>
                                            Answer
                                        </div>
                                        <div className='chatbotresponse' dangerouslySetInnerHTML={{ __html: item.response }} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}

                    {visibleCount < chathistory.length && (
                        <div ref={triggerRef} style={{ height: '50px', textAlign: 'center' }}>
                            Loading more...
                        </div>
                    )}

                    {chathistory?.length === 0 && (
                        <div className="min-h-200 d-flex align-items-center justify-content-around">
                            <Noresult />
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
